import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { UserType } from "../models/base/UserType";
import { AddUserRequest} from "../models/user/user.request";
import { AdminDashboardStatsDTO, ClientProfileInfoDTO, ClientProfileModalInfoDTO, GetUserOwnerDTO, OwnerSelectResponseDTO, UserBasicInfoDTO, UserModalInfoDTO, UserTableInfoDTO, UserWorkerLocalInfoSelectDTO } from "../models/user/user.response";

export const userService = {

    async addUser(userData: AddUserRequest): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/users/add", userData);
        return data;
    },

    async getOwners(): Promise<ApiResponse<GetUserOwnerDTO[]>> {
        const { data } = await api.get<ApiResponse<GetUserOwnerDTO[]>>("/users/owners");
        return data;
    },

    async delete(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/users/${id}/delete`);
        return data;
    },

    async deleteHard(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/users/${id}`);
        return data;
    },

    async restore(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/users/${id}/restore`);
        return data;
    },

    async getSelect(userType: UserType): Promise<ApiResponse<OwnerSelectResponseDTO[]>> {
        const { data } = await api.get<ApiResponse<OwnerSelectResponseDTO[]>>(`/users`, { params: { userType: "Admin" } });
        return data;
    },

    async registerClient(form: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`users/register-client`, form);
        return data;
    },

    async getClientProfileInfo(): Promise<ApiResponse<ClientProfileInfoDTO>> {
        const { data } = await api.get<ApiResponse<ClientProfileInfoDTO>>(`users/client-profile`);
        return data;
    },

    async updateClientProfile(userId: string, dto: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`users/${userId}/client-profile`, dto);
        return data;
    },

    async getUserModalInfo(userId: string): Promise<ApiResponse<UserModalInfoDTO>> {
        const { data } = await api.get<ApiResponse<UserModalInfoDTO>>(`users/${userId}/client-profile`);
        return data;
    },

    async getUserWithClientProfile(): Promise<ApiResponse<UserTableInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<UserTableInfoDTO[]>>(`users/settings/client-profile`);
        return data;
    },

    async getClientProfileModalInfo(userId: string): Promise<ApiResponse<ClientProfileModalInfoDTO>> {
        const { data } = await api.get<ApiResponse<ClientProfileModalInfoDTO>>(`users/${userId}/settings/client-profile`);
        return data;
    },

    async getSuperAdminDashboardInfo(): Promise<ApiResponse<AdminDashboardStatsDTO>> {
        const { data } = await api.get<ApiResponse<AdminDashboardStatsDTO>>(`users/super-admin/dashboard`);
        return data;
    },

    async getBasicInfo(userId: string): Promise<ApiResponse<UserBasicInfoDTO>> {
        const { data } = await api.get<ApiResponse<UserBasicInfoDTO>>(`users/${userId}/basic-info`);
        return data;
    },

    async getLocalsForWorkerSelect(id: string): Promise<ApiResponse<UserWorkerLocalInfoSelectDTO[]>> {
        const { data } = await api.get<ApiResponse<UserWorkerLocalInfoSelectDTO[]>>(`users/${id}/work-locals`);
        return data;
    },

}